var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"listShow2"},[_vm._v("\n    清除缓存\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/._vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-23edcb24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/._vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Clear.vue
// module id = null
// module chunks = 